import Eras from '@/roc/era';
import Grid from '@/roc/grid/Grid';

const serializeBuildings = function (buildings) {
  const serialized = [];

  for (let i = 0; i < buildings.length; i++) {
    serialized.push(
      buildings[i].serialize()
    );
  }

  return serialized;
};

const serializeExpansions = function (expansions) {
  const result = [
    'e'
  ];

  for (let i = expansions.length - 1; i >= 0; i--) {
    result.push(expansions[i].x + ',' + expansions[i].y);
  }

  return result.join(':');
};

const serializeWonders = function (wonders) {
  const result = [
    'w'
  ];

  for (let i = 0; i < wonders.length; i++) {
    result.push(
      wonders[i].id +
      ',' +
      wonders[i].level +
      ',' +
      (wonders[i].active ? 1 : 0)
    );
  }

  return result.join(':');
};

const serializeArtifacts = function (artifacts) {
  const result = [
    'a'
  ];

  for (let i = 0; i < artifacts.length; i++) {
    result.push(
      artifacts[i].id +
      ',' +
      (artifacts[i].active ? 1 : 0)
    );
  }

  return result.join(':');
};

const encodeToURL = function (era, wonders, artifacts, expansions, buildings) {
  const header = [
    Eras[era].id,
    Grid.CELL_COUNT_X,
    Grid.CELL_COUNT_Y,
  ];

  const params = [
    header.join('.'),
  ];

  params.push(
    ...serializeBuildings(buildings)
  );

  params.push(
    serializeExpansions(expansions)
  );

  params.push(
    serializeWonders(wonders)
  );

  params.push(
    serializeArtifacts(artifacts)
  );

  return params;
};

export default {
  encodeToURL
};
